/**
 * URL do backend para desenvolvimento local.
 * Defina REACT_APP_BACKEND_URL no `.env` do frontend se a API não estiver em :8000.
 */
const rawUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

// Garante que não haja uma barra no final para evitar URLs duplas como //api
export const BACKEND_URL = rawUrl.endsWith('/') ? rawUrl.slice(0, -1) : rawUrl;

export const MASTER_ADMIN_USERNAME = process.env.REACT_APP_MASTER_ADMIN_USERNAME || 'admin';
